<!-- eslint-disable no-unused-vars -->
<script setup>
import { ref, useTemplateRef, defineExpose, nextTick, computed, reactive, defineEmits } from 'vue'
import { MY_CONSTANTS } from '@/util/constants'
import CryptoJS from 'crypto-js'
import EventBus from '@/components/schoolInstrument/mixins/EventBus';
import { getcommandlist, getoptionsbyvoice } from '@/port/admins/ai.js'
import { ElMessage } from 'element-plus';


const SILENCE_TIMEOUT = 3000

const voiceList = [
  { label: '晓晓 (女声·温柔)', value: 'Microsoft Xiaoxiao' },
  { label: '云希 (男声·清朗)', value: 'Microsoft Yunxi' },
  { label: '云扬 (男声·阳光)', value: 'Microsoft Yunyang Online' },
  { label: '晓伊 (女声·甜美)', value: 'Microsoft Xiaoyi Online' },
  { label: '云健 (男声·稳重)', value: 'Microsoft Yunjian Online' },
  { label: '云夏 (男声·热情)', value: 'Microsoft Yunxia Online' },
  { label: '晓呗 (女声·辽宁)', value: 'Microsoft Xiaobei Online' },
  { label: '晓妮 (女声·陕西)', value: 'Microsoft Xiaoni Online' }
]

const emit = defineEmits(['close'])

const visible = ref(false)
const isAnimating = ref(false)     // 记录是否正在飞入
const showFinalContent = ref(false) // 记录是否切换到正式业务容器
const showFinalIcon = ref(false) // 记录是否切换到正式业务容器
const isExpanded = ref(false)      // 记录内容是否展开
const customdeskId = ref('') // 场景ID

const voiceConfig = ref({}) // 语音的配置信息

const requestParams = reactive({
	common: {
		app_id: '' // 应用 ID
	},
	business: {
		language: 'zh_cn', // 语种
		domain: 'iat', // 领域
		accent: 'mandarin', // 方言
		vad_eos: SILENCE_TIMEOUT, // 讯飞的静音超时设置 (毫秒)
		dwa: 'wpgs', // 动态修正
		pd: 'game', // 场景
		ptt: 0, // 不带标点符号
		rlang: 'zh-cn',
		vinfo: 1,
		nbest: 1,
		wbest: 1,
	},
	data: {
		status: 0, // 帧状态：0-开始，1-传输中，2-结束
		format: 'audio/L16;rate=16000', // 音频格式
		encoding: 'raw', // 编码
		audio: '' // 音频数据 Base64 编码
	}
});

const config = reactive({
	appId: '89046a2b', // 讯飞APP ID
	apiKey: 'fd322a5504f1ece38ee912e5fb91e891', // 讯飞API Key
	apiSecret: 'YTk2YzAwNTAxZmQ4YTc1MDQ2YWJjOTU1', // 讯飞API Secret
	language: 'zh_cn', // 默认中文 (讯飞参数)
});
const isConnecting = ref(false) // 是否正在连接（防止重复点击）
const isConnected = ref(false) // WebSocket是否已连接
const isRecording = ref(false) // 是否正在录音并传输数据
const isTodoBtn = ref(false) // 是否正在处理 AI 语音命令 (防止重复提交)
const userMsg = ref(null) // 用于存储 localStorage.getItem("userMsg") 的结果 (用户/学校信息)
// Media Source Extension (MSE) 相关（用于播放 TTS 音频流）
const audioChunks = reactive([]) // 用于缓存 TTS 音频数据的数组
// WebSocket相关 (讯飞 IAT)
const ws = ref(null) // AudioContext 实例
const wsUrl = ref('') // MediaStream 实例 (麦克风输入)
// 音频录制相关 (Web Audio API)
const audioContext = ref(null) // AudioContext 实例
const audioStream = ref(null) // MediaStream 实例 (麦克风输入)
const analyser = ref(null) // AudioAnalyserNode (用于语音可视化，传递给 VoiceImage 组件)
const processor = ref(null) // ScriptProcessorNode (处理麦克风数据并发送给 WebSocket)
// 转写结果
const currentTranscription = ref('') // 当前的语音转写结果
const silenceTimer = ref(null) // 用于自定义静音检测的计时器
const isVoiceTime = ref(false) // 是否正在进行 TTS 语音播放流程


// refs
const animeImgRef = useTemplateRef('animeImgRef')
const voicePlayer = useTemplateRef('voicePlayer')

// 记录起始和终点坐标
const startStatus = ref({ left: '0', top: '0', width: '0', height: '0' })
const endStatus = ref({ 
  left: 'calc(50vw - 376px - 111px)', 
  top: 'calc(50vh - 133.5px - 56px)' 
})

const open = (opt) => {
  const { position, config, id } = opt
  startStatus.value = position
  voiceConfig.value = config
  customdeskId.value = id
  
  // 初始化状态
  visible.value = true
  isAnimating.value = false
  showFinalContent.value = false
  isExpanded.value = false

  nextTick(() => {
    // 强制重绘，确保起始位置被浏览器捕获
    void animeImgRef.value.offsetWidth; 
    isAnimating.value = true
  })
}

// 飞入动画结束
const onImgAnimationEnd = () => {
  if (!isAnimating.value) return
  isAnimating.value = false
  showFinalContent.value = true
  // 这里不需要额外的 setTimeout，由 @animationend 处理
}

// 头像淡入动画结束触发（最终容器内）
const handleUserAnimationEnd = () => {
  // 触发内容宽度从 0 到 100% 的展开
  isExpanded.value = true
}

const close = () => {
  voicePlayer.value.pause() // 暂停 TTS 播放
  stopRecording()
  visible.value = false
  emit('close')
}

const handleContentAnimationEnd = () => {
  showFinalIcon.value = true
  toggleRecording()
}

const getVoiceType = function(type) {
	const result = voiceList.find(item => item.value === type)
	return result ? result.value : 'Microsoft Xiaoxiao'
}

const resetSilenceTimer = function() {
	if (silenceTimer.value) {
		clearTimeout(silenceTimer.value);
	}
	// 重新设置计时器，达到 SILENCE_TIMEOUT 毫秒后自动断开录音
	silenceTimer.value = setTimeout(() => {
		console.log('2秒静音检测，自动断开。');
		// 确保在静音断开时，只有在正在录音状态下才执行
		if (isRecording.value) {
			stopRecording();
		}
	}, SILENCE_TIMEOUT);
}

const isVoiceActivity = function(inputData) {
	// 简单的RMS（均方根）计算，作为音量指示
	let sumOfSquares = 0;
	for (let i = 0; i < inputData.length; i++) {
		sumOfSquares += inputData[i] * inputData[i];
	}
	const rms = Math.sqrt(sumOfSquares / inputData.length);

	// 阈值：可以根据实际环境噪音调整，0.01 是一个常见的小声阈值
	const VOICE_THRESHOLD = 0.01;

	return rms > VOICE_THRESHOLD;
}

const openBtn = function(value) {
	if (value) {
		isTodoBtn.value = true;

		// 获取用户/学校信息
		if (!userMsg.value) {
			let user = localStorage.getItem("userMsg");
			if (user) {
				userMsg.value = JSON.parse(user);
			}
		}

		if (userMsg.value) {
			const param = {
				curpage: 1,
				pagesize: 1,
				customdeskId: customdeskId.value,
				yymsg: value, // 转写得到的语音信息
				schoolId: userMsg.value.schoolMsg.schoolId
			}
			// 调用后台接口获取对应的按钮命令
			getcommandlist(param).then(res => {
				if (res.code === 0) {
					if (res.data.buttonId) {
						// 成功找到命令，存入 localStorage 并通过 EventBus 触发
						localStorage.setItem('currentTranscription', JSON.stringify({ text: value,
							isAi: false }))
						EventBus.emit('openBtn', { id: Number(res.data.buttonId),
							name: res.data.name });
            isTodoBtn.value = false // 命令处理结束
            close()
					} else {
						// 先走老谭的id匹配 再走郑工AI匹配
						const param = {}
						const li = []
						const voiceConfig = voiceInfo.value.voiceConfig || []
						for (const ele of voiceConfig) {
							if (ele.children) {
								for (const cele of ele.children) {
									li.push(cele)
								}
							}
						}
						param.options = li
						param.question = value
						getoptionsbyvoice(param).then(res => {
							if (res.data.length !== 0) {
								localStorage.setItem('currentTranscription', JSON.stringify({ text: value,
									isAi: false }))
								EventBus.emit('openBtn', { id: Number(res.data[0].id),
									name: res.data[0].name });
							} else {
								ElMessage({
									type: 'error',
									message: '未找到匹配的按钮'
								})
							}
						}).finally(() => {
              isTodoBtn.value = false // 命令处理结束
              close()
						})
					}
				}
			})
		} else {
      isTodoBtn.value = false
      close()
		}
	}
}

const getMicAccess = async function() {
	// 如果音频流已存在，直接返回成功
	if (audioStream.value) return true;

	try {
		// 请求麦克风权限，设置音频参数 (单声道, 16000 采样率, 启用回声消除和降噪)
		audioStream.value = await navigator.mediaDevices.getUserMedia({
			audio: {
				channelCount: 1,
				sampleRate: 16000,
				echoCancellation: true,
				noiseSuppression: true
			}
		});

		// 创建音频上下文，设置采样率为 16000 (与讯飞要求一致)
		audioContext.value = new (window.AudioContext || window.webkitAudioContext)({
			sampleRate: 16000
		});

		return true;
	} catch (error) {
		console.error('无法访问麦克风:', error);
		alert('无法访问麦克风，请检查权限设置');
		return false;
	}
}

const toggleRecording = async function() {
	if (isRecording.value) {
		// 状态为录音中，点击则停止
		console.log('手动点击，停止录音。');
		stopRecording();
	} else {
		// 状态为停止，点击则开始 TTS 语音提示流程
		openAiVoice()
	}
}

const openAiVoice = function() {
	// 防止重复启动
	if (isVoiceTime.value) return
	isVoiceTime.value = true
	if (voiceInfo.value.voiceBroadcast === false) {
		// if (true) {
		const audio = voicePlayer.value
		if (!audio.src) {
			audio.src = 'https://bigdata.topeti.com/wechatRepository/image/voiceBroadcast.MP3'
		}
		openAudio()
		return
	}
	if (audioChunks.length !== 0) {
    // 不用再去websocket了，重新播放音频就好了
    console.log('123123123')
		openAudio()
		return
	}
	// 准备 TTS 文本和声音参数
	let text1 = '你好，有什么可以帮助你的吗？'
	if (voiceInfo.value.avatarConfig && voiceInfo.value.avatarConfig.text1) {
		text1 = voiceInfo.value.avatarConfig && voiceInfo.value.avatarConfig.text1
	}

	// 如果 TTS 文本为空，直接跳过 TTS 流程，启动录音
	if (!text1 || text1.trim() === '') {
		isVoiceTime.value = false; // 重置状态
		openRecording();
		return;
	}

	const text = text1
	const voice = getVoiceType(voiceInfo.value.voiceType || 'Microsoft Xiaoxiao')
	const rate = 0
	// 构造 TTS WebSocket URL
	// const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
	const wsUrl = `wss://user.topeti.com/api/tts/stream`
	const webSocket = new WebSocket(wsUrl);

	webSocket.onopen = function () {
		console.log('TTS WebSocket连接已打开');
		// 发送 TTS 请求
		const request = {
			text: text,
			voice: voice,
			rate: rate,
			volume: 100,
		};
		webSocket.send(JSON.stringify(request));
	};

	// 接收 TTS 音频数据块
	webSocket.onmessage = (event) => {
		if (typeof event.data === 'string') {
			if(event.data.startsWith('{')){
				let fd = JSON.parse(event.data);
				if (fd.type === 'end') {
					setTimeout(() => {
						playAudio()
					}, 100);
				}
			}
		} else {
			if (event.data instanceof Blob) {
				event.data.arrayBuffer().then(d => {
					handleAudioChunk(d);
				});
			} else {
				handleAudioChunk(event.data);
			}
		}
	};

	webSocket.onclose = function () {
		isVoiceTime.value = false // 重置状态，无论成功与否
	};

	webSocket.onerror = function (error) {
		console.log('TTS WebSocket错误: ' + error, 'error');

		// **关键修改：TTS 发生错误时，立即启动录音，确保流程继续**
		isVoiceTime.value = false // 重置状态
	};
}

const openAudio = function() {
  const audio = voicePlayer.value
  console.log(audio,'audioaudio')
  audio.play().catch((err) => {
    console.log(err)
  })
	audio.onended = () => {
		isVoiceTime.value = false
		openRecording()
	}
}

const playAudio = function() {
	if (audioChunks.length === 0) return;

	try {
		// 合并所有音频块
		const totalLength = audioChunks.reduce((sum, chunk) => sum + chunk.byteLength, 0);
		const audioData = new Uint8Array(totalLength);
		let offset = 0;
		audioChunks.forEach(chunk => {
			audioData.set(new Uint8Array(chunk), offset);
			offset += chunk.byteLength;
		});

		// 创建Blob并播放
		const blob = new Blob([audioData], { type: 'audio/mp3' });
		const url = URL.createObjectURL(blob);

    const audio = voicePlayer.value
    
		audio.src = url;

		audio.onended = () => {
			// URL.revokeObjectURL(url)
			isVoiceTime.value = false
			openRecording()
		};
		audio.play().catch(error => {
			console.error('播放错误:', error);
		});
	} catch (error) {
		console.log(error,'error')
	}
}

const handleAudioChunk = function(chunk) {
	if (!chunk) return;
	audioChunks.push(chunk);
}

const openRecording = async function() {
	// --- 优化：并行启动两个阻塞操作，减少首次延迟 ---
	if (isConnecting.value) return; // 防止重复点击连接
	isConnecting.value = true;

	// 1. 立即请求麦克风权限 (用户阻塞步骤)
	const micReadyPromise = getMicAccess();

	// 2. 立即开始 WebSocket 连接 (网络阻塞步骤)
	const wsConnectPromise = connectIflytek(true);

	// 3. 等待两者都完成
	const [micReady, wsReady] = await Promise.all([micReadyPromise, wsConnectPromise]);

	isConnecting.value = false; // 无论成功与否，连接过程结束

	// 4. 如果连接和麦克风都OK，则启动数据传输
	if (wsReady && micReady) {
		startRecording();
	} else {
		// 如果失败，确保清理资源
		disconnectIflytek();
		if (audioStream.value) {
			audioStream.value.getTracks().forEach(track => track.stop());
			audioStream.value = null;
		}
		if (audioContext.value) {
			audioContext.value.close();
			audioContext.value = null;
		}
	}
}

const generateWebSocketUrl = function() {
	const host = 'iat-api.xfyun.cn';
	const path = '/v2/iat';

	const date = new Date().toUTCString(); // 当前时间 UTC 格式

	// 签名原始字符串
	const signatureOrigin = `host: ${host}\ndate: ${date}\nGET ${path} HTTP/1.1`;

	// 使用 HMAC-SHA256 和 apiSecret 进行签名
	const signatureSha = CryptoJS.HmacSHA256(signatureOrigin, config.apiSecret);
	const signature = CryptoJS.enc.Base64.stringify(signatureSha);

	// 构造 Authorization 字段
	const authorizationOrigin = `api_key="${config.apiKey}", algorithm="hmac-sha256", headers="host date request-line", signature="${signature}"`;
	const authorization = btoa(authorizationOrigin); // Base64 编码

	// 构造查询参数
	const queryParams = {
		host,
		date,
		authorization
	};

	// 拼接成 URL 查询字符串
	const queryString = Object.keys(queryParams)
		.map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
		.join('&');

	// 最终的 WebSocket URL
	return `wss://${host}${path}?${queryString}`;
}

const connectIflytek = function(isInitial = false) {
	// 检查配置是否完整
	if (!config.appId || !config.apiKey || !config.apiSecret) {
		alert('请先填写完整的讯飞API配置信息');
		return Promise.resolve(false);
	}

	return new Promise(resolve => {
		try {
			wsUrl.value = generateWebSocketUrl(); // 生成签名 URL
			ws.value = new WebSocket(wsUrl.value); // 创建 WebSocket 实例

			// 设置请求参数
			requestParams.common.app_id = config.appId;
			requestParams.business.language = config.language;
			requestParams.business.vad_eos = SILENCE_TIMEOUT;

			// WebSocket 连接成功
			ws.value.onopen = () => {
				console.log('WebSocket连接已建立');
				isConnected.value = true;

				// 发送 start frame (状态 0)
				const startFrame = {
					common: requestParams.common,
					business: requestParams.business,
					data: {
						status: 0,
						format: 'audio/L16;rate=16000',
						encoding: 'raw',
						audio: ''
					}
				};
				ws.value.send(JSON.stringify(startFrame));

				if (isInitial) resolve(true); // 通知 openRecording 连接已完成
			};

			// 接收到讯飞的转写结果
			ws.value.onmessage = (event) => {
				handleWebSocketMessage(event);
			};

			// WebSocket 发生错误
			ws.value.onerror = (error) => {
				console.error('WebSocket错误:', error);
				isConnected.value = false;
				if (isInitial) resolve(false);
			};

			// WebSocket 连接关闭
			ws.value.onclose = () => {
				console.log('WebSocket连接已关闭');
				isConnected.value = false;
				isRecording.value = false;
				// 清理静音计时器
				if (silenceTimer.value) {
					clearTimeout(silenceTimer.value);
					silenceTimer.value = null;
				}
			};

		} catch (error) {
			console.error('连接失败:', error);
			alert('连接失败: ' + error.message);
			if (isInitial) resolve(false);
		}
	});
}

const handleWebSocketMessage = function(event) {
	try {
		const response = JSON.parse(event.data);

		if (response.code !== 0) {
			console.error('讯飞API返回错误:', response);
			return;
		}

		if (response.data && response.data.result) {
			const result = response.data.result;
			const transcribeText = parseTranscribeResult(result);

			if (transcribeText) {
				// 如果是中间结果 (status === 1)
				if (response.data.status === 1) {
					currentTranscription.value = transcribeText;
				}
			}
		}

		// 核心修改：处理最终结果 (status === 2)，这是讯飞自带的 VAD/静音断开
		if (response.data && response.data.status === 2) {
			console.log('讯飞 VAD/静音检测，转写结束');
			stopRecording(); // 收到最终帧，手动停止本地录音流程
		}

	} catch (error) {
		console.error('解析响应数据失败:', error);
	}
}

const parseTranscribeResult = function(result) {
	try {
		let text = '';
		const ws = result.ws; // 词语数组 (words)

		for (let i = 0; i < ws.length; i++) {
			const cw = ws[i].cw; // 候选词数组 (candidates)
			for (let j = 0; j < cw.length; j++) {
				text += cw[j].w; // 拼接文本
			}
		}

		return text;
	} catch (error) {
		console.error('解析转写结果失败:', error);
		return '';
	}
}

const startRecording = function() {
	if (!isConnected.value || !audioStream.value) {
		console.error('无法启动录音: WS或麦克风未就绪');
		return;
	}

	// 创建媒体流源 (从麦克风获取数据)
	const source = audioContext.value.createMediaStreamSource(audioStream.value);

	// 创建分析器用于音频可视化 (传递给 VoiceImage 组件)
	analyser.value = audioContext.value.createAnalyser();
	analyser.value.fftSize = 256;
	source.connect(analyser.value);

	// 创建脚本处理器 (用于获取和处理音频数据)
	// 缓冲区大小 4096，输入通道 1，输出通道 1
	processor.value = audioContext.value.createScriptProcessor(4096, 1, 1);
	source.connect(processor.value); // 将麦克风源连接到处理器
	processor.value.connect(audioContext.value.destination); // 连接到目标 (保证音频流持续)

	// 核心：音频数据处理事件
	processor.value.onaudioprocess = (event) => {
		// 只有在录音中且 WebSocket 开启时才发送数据
		if (isRecording.value && ws.value && ws.value.readyState === WebSocket.OPEN) {
			const inputData = event.inputBuffer.getChannelData(0); // 获取浮点型音频数据

			// 检测音量，如果有声音则重置计时器 (自定义 VAD 逻辑)
			if (isVoiceActivity(inputData)) {
				resetSilenceTimer();
			}

			// 数据格式转换：浮点型转 16 位 PCM 整数
			const int16Data = floatTo16BitPCM(inputData);
			// 转换为 Base64 编码
			const base64Data = arrayBufferToBase64(int16Data.buffer);

			// 构造数据帧 (状态 1)
			const audioFrame = {
				data: {
					status: 1, // 传输中
					format: 'audio/L16;rate=16000',
					encoding: 'raw',
					audio: base64Data
				}
			};

			// 发送音频数据
			ws.value.send(JSON.stringify(audioFrame));
		}
	};

	isRecording.value = true;
	resetSilenceTimer(); // 开始录音时启动自定义静音计时器
	console.log('录音数据传输开始');
}

const stopRecording = function() {
	if (!isRecording.value) return;

	// 清理静音计时器
	if (silenceTimer.value) {
		clearTimeout(silenceTimer.value);
		silenceTimer.value = null;
	}

	// 发送结束帧 (状态 2)
	if (ws.value && ws.value.readyState === WebSocket.OPEN) {
		const endFrame = {
			data: {
				status: 2, // 结束
				format: 'audio/L16;rate=16000',
				encoding: 'raw',
				audio: ''
			}
		};

		ws.value.send(JSON.stringify(endFrame));
	}

	// 断开 ScriptProcessorNode 和音频流
	if (processor.value && audioContext.value) {
		processor.value.disconnect();
		processor.value.onaudioprocess = null;
		processor.value = null;
	}

	// 停止麦克风轨道，释放麦克风资源
	if (audioStream.value) {
		audioStream.value.getTracks().forEach(track => track.stop());
		audioStream.value = null;
	}

	// 关闭音频上下文
	if (audioContext.value) {
		audioContext.value.close();
		audioContext.value = null;
	}

	isRecording.value = false;
	isVoiceTime.value = false // TTS 流程结束
	disconnectIflytek() // 断开讯飞 WebSocket 连接
  if (visible.value) {
    // 处理最终的转写结果（例如：执行命令）
    openBtn(currentTranscription.value)
    currentTranscription.value = ''; // 清空当前转写结果
  }

	console.log('停止录音');
}

const disconnectIflytek = function() {
	if (ws.value) {
		ws.value.close();
		ws.value = null;
	}

	isConnected.value = false;
	isRecording.value = false;
}

const floatTo16BitPCM = function(input) {
	const output = new Int16Array(input.length);
	for (let i = 0; i < input.length; i++) {
		const s = Math.max(-1, Math.min(1, input[i])); // 钳制在 [-1, 1]
		// 转换为 16 位整数范围
		output[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
	}
	return output;
}

const arrayBufferToBase64 = function(buffer) {
	let binary = '';
	const bytes = new Uint8Array(buffer);
	const len = bytes.byteLength;
	for (let i = 0; i < len; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	// 使用浏览器自带的 btoa 函数进行 Base64 编码
	return window.btoa(binary);
}




// computed
const getImgUrl = computed(() => {
  const defaultUrl = 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-enterprise-0.png';
  const info = voiceConfig.value?.overAllStyle?.voiceInfo;
  if (info?.avatarConfig) {
    if (info.avatarConfig.avatarId) {
      return `https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-${info.avatarConfig.avatarId}.png`;
    } else if (info.avatarConfig.halfBodyImage) {
      return `${MY_CONSTANTS.$imgurl}/userfiles/${info.avatarConfig.halfBodyImage}`;
    }
  }
  return defaultUrl;
})

const voiceTips = computed(() => {
	const avatarConfig = voiceConfig.value?.overAllStyle?.voiceInfo?.avatarConfig;
	if (avatarConfig?.searchVal) {
		return avatarConfig.searchVal;
	} else {
		return '我是AI助理，需要什么帮忙？'
	}
})

const voiceInfo = computed(() => {
	// 获取配置中的语音信息（如 TTS 文本和声音类型）
	if (voiceConfig.value.overAllStyle && voiceConfig.value.overAllStyle.voiceInfo && voiceConfig.value.overAllStyle.voiceInfo) {
		return voiceConfig.value.overAllStyle.voiceInfo
	} else {
		return {}
	}
})


defineExpose({ open })
</script> 

<template>
  <Teleport to="body">
    <div class="voice-pop" v-if="visible" :class="{ 'is-active': visible }" @click="close">
      <img 
        v-if="!showFinalContent"
        ref="animeImgRef"
        :src="getImgUrl" 
        class="anime-flying-img"
        :class="{ 'is-flying': isAnimating }"
        :style="{
          '--s-left': startStatus.left,
          '--s-top': startStatus.top,
          '--s-width': startStatus.width,
          '--s-height': startStatus.height,
          '--e-left': endStatus.left,
          '--e-top': endStatus.top
        }"
        @transitionend="onImgAnimationEnd"
        @click.stop
      >
      <div class="voice-pop-container" v-if="showFinalContent" @click.stop>
        <div 
          class="voice-pop-content" 
          :class="{ 'is-expanded': isExpanded }"
          @transitionend="handleContentAnimationEnd"
        >
        <div class="voice-pop-content-tips">语音智能识别</div>
        <div class="voice-pop-content-rainbow">
          <img src="./voice-loading.gif" class="rainbow-img" v-if="isRecording">
        </div>
        <template v-if="isRecording">
          <div class="voice-pop-content-title">
            {{ currentTranscription }}
          </div>
        </template>
        <template v-if="!isRecording && !isTodoBtn">
          <div class="voice-pop-content-title">
            {{ voiceTips }}
          </div>
        </template>
        <template v-if="isTodoBtn">
          <div class="voice-pop-content-radar">
            <img src="./voice-radar.gif" alt="">
          </div>
          <div class="voice-pop-content-loading">
            正在为您查询，请稍后...
          </div>
        </template>
        </div>

        <div class="voice-pop-user" @animationend="handleUserAnimationEnd">
          <img :src="getImgUrl" alt="">
        </div>

        <div class="voice-pop-close" @click="close" v-if="showFinalIcon">
          <el-icon><Close /></el-icon>
        </div>
      </div>
      <audio ref="voicePlayer" style="display: none;" />
    </div>
  </Teleport>
</template>

<style scoped lang='scss'>
.voice-pop {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color .3s;
  pointer-events: none;

  &.is-active {
    background-color: rgba(0, 0, 0, 0.6);
    pointer-events: auto;
  }

  // 1. 飞行图片
  .anime-flying-img {
    position: fixed;
    z-index: 1000000;
    left: var(--s-left);
    top: var(--s-top);
    width: var(--s-width);
    height: var(--s-height);
    transition: all .6s cubic-bezier(0.34, 1.56, 0.64, 1);
    will-change: left, top, width, height;
  }

  .is-flying {
    left: var(--e-left) !important;
    top: var(--e-top) !important;
    width: 321px !important;
    height: 318px !important;
  }

  // 2. 最终内容容器
  &-container {
    width: 752px;
    height: 267px;
    position: relative;
  }

  &-close {
    position: absolute;
    right: -28px;
    top: -28px;
    color: #FFFFFF;
    font-size: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  &-content {
    width: 0; /* 初始宽度为0 */
    height: 100%;
    overflow: hidden; /* 核心：隐藏超出内容 */
    background-image: url('./voice-content-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left center;
    border-radius: 10px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    /* 宽度展开动画 */
    transition: width .6s cubic-bezier(0.16, 1, 0.3, 1), padding .6s;
    box-sizing: border-box;
    
    &.is-expanded {
      width: 100% !important;
      padding: 0 70px 0 245px !important;
    }

    &-title {
      min-width: 450px; /* 防止展开时文字自动换行抖动 */
      color: #FFFFFF;
      font-size: 20px;
    }

    &-radar {
      width: 220px;
      height: 220px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    &-loading {
      margin-left: 30px;
      font-family: uniqueID;
      color: #FFFFFF;
      font-weight: 400;
      font-size: 18px;
    }

    &-tips {
      position: absolute;
      right: 22px;
      top: 20px;
      color: transparent;
      font-weight: 400;
      font-size: 20px;
      background: linear-gradient(180deg, rgba(129, 228, 255, 1) 0%, rgba(255, 255, 255, 1) 100%);
      background-clip: text;
    }

    &-rainbow {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 100px;
      height: 100px;
      background: url('./voice-rainbow.png') no-repeat center/contain;
      display: flex;
      align-items: center;
      justify-content: center;
      .rainbow-img { width: 60px; }
    }
  }

  &-user {
    left: -111px;
    top: -54px;
    position: absolute;
    width: 321px;
    height: 318px;
    animation: userFadeIn .3s forwards;
    img { width: 100%; }
  }
}

@keyframes userFadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>